<template>
    <div class="transferBlockSec" style="padding-bottom: 0px;" >
        <div class="container home-chart recent-transactions-panel">
          <div class="header d-flex">
            <a class="title-wrap" href="#/blockchain/transactions">
              <span>Transactions</span>
            </a>
          </div>
          <div class="content" style="">
            <div class="row-flex" style="">
              <div class="col-56 home-translations-table">
                <div class="card">
                  <ul class="list-group list-group-flush list-group-pc">
                    <li class="list-group-item transactions-body list-group-item-en">
                      <div class="list-item-cont">
                        <div class="hash-body mb-0 d-flex">
                          <div class="d-flex flex-shrink-1 flex-grow-1 flex-column align-items-start hash-link-item">
                            <div class="ln1 it1 d-flex flex-grow-1 color-transfers-hash transaction-hash">
                              <div class="hash">
                                <div class="truncate-ellipsis">
                                  <span>
                                    <a class="color-tron-100 list-item-word" href="#/transaction/12e71e11018e7d5dc0da229cf7e51b9a44ef75268e88d675f8cc26c0b7c549ae">
                                      <div class="ellipsis_box">
                                        <div class="ellipsis_box_start">12e71e11018e7d5dc0da229cf7e51b9a44ef75268e88d675f8cc26c0b7c</div>
                                        <div class="ellipsis_box_end">549ae</div>
                                      </div>
                                    </a>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="ln2 it1 d-flex list-item-word it1">
                              <div class="tron-text-right tron-font-size-12px tron-color-gray-dark">
                                <div class="token_black table_pos">
                                  <div>8 secs ago</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="d-flex address-item">
                            <div class=" d-flex flex-column text-left">
                              <span class="d-flex ln1 it2">
                                <div class="tron-color-gray-dark transactionAddressTitle en" style="white-space: nowrap;">
                                  <span>From</span>
                                </div>
                                <span class="address-container address_max_width_home  ">
                                  <div class="react-contextmenu-wrapper">
                                    <span>
                                      <div class="truncate-ellipsis">
                                        <span>
                                          <div class="d-flex address-link-wrap " style="align-items: center;">
                                            <a class="text-truncate address-link " href="#/address/TLaGjwhvA8XQYSxFAcAXy7Dvuue9eGYitv">
                                              <span class="">
                                                <div class="ellipsis_box tag-background">
                                                  <div class="d-inline-block line-ellipsis">OKX Hot Wallet 8</div>
                                                </div>
                                              </span>
                                            </a>
                                            <div class="labelShow"></div>
                                          </div>
                                        </span>
                                      </div>
                                    </span>
                                  </div>
                                  <span class="new-address-content-menu-wrap">
                                    <nav role="menu" tabindex="-1" class="react-contextmenu dropdown-menu show new-address-content-menu" style="z-index: 899; position: fixed; opacity: 0; pointer-events: none;"></nav>
                                  </span>
                                </span>
                              </span>
                              <span class="d-flex ln2 it2 transactionToAddressWrapper" style="position: relative;">
                                <div class="tron-color-gray-dark transactionAddressTitle en" style="white-space: nowrap;">
                                  <span>To</span>
                                </div>
                                <span class="d-flex">
                                  <span class="address-container address_max_width_home  ">
                                    <div class="react-contextmenu-wrapper">
                                      <span>
                                        <div class="truncate-ellipsis">
                                          <span>
                                            <div class="d-flex address-link-wrap label-address-link-wrap" style="align-items: center;">
                                              <a class="text-truncate address-link tron-width-100 personal-address-link" href="#/contract/TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t/code">
                                                <div class="d-flex align-items-center">
                                                  <span class="flagIcon">
                                                    <svg class="icon tron-icon contract-icon" aria-hidden="true">
                                                      <use xlink:href="/static/media/icons.svg#icon-icon-sc"></use>
                                                    </svg>
                                                  </span>
                                                  <div class="ellipsis_box tag-background contract-content-width ">
                                                    <div class="d-inline-block line-ellipsis">USDT Token</div>
                                                  </div>
                                                </div>
                                              </a>
                                              <div class="labelShow"></div>
                                            </div>
                                          </span>
                                        </div>
                                      </span>
                                    </div>
                                    <span class="new-address-content-menu-wrap">
                                      <nav role="menu" tabindex="-1" class="react-contextmenu dropdown-menu show new-address-content-menu" style="z-index: 899; position: fixed; opacity: 0; pointer-events: none;"></nav>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </div>
                          </div>
                          <div class="transaction-type-box">
                            <div class="ln1 it3">
                              <div class="color-grey-200 d-flex it3" style="font-size: 14px;">
                                <span class="d-inline-block text-truncate" style="max-width: 90px;">
                                  <span class="tron-mr-2px">0</span>
                                </span>
                                <div>
                                  <div>
                                    <span style="">
                                      <a class="" href="#/token/0">TRX</a>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="ln2 d-flex flex-column transaction-type it3">
                              <div class="k-value-wrap">
                                <span class="k-value whitelist">Transfer</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item transactions-body list-group-item-en">
                      <div class="list-item-cont">
                        <div class="hash-body mb-0 d-flex">
                          <div class="d-flex flex-shrink-1 flex-grow-1 flex-column align-items-start hash-link-item">
                            <div class="ln1 it1 d-flex flex-grow-1 color-transfers-hash transaction-hash">
                              <div class="hash">
                                <div class="truncate-ellipsis">
                                  <span>
                                    <a class="color-tron-100 list-item-word" href="#/transaction/f5ae27123be31d06ab8fc03eacb5732ae35f0838ebae53730a4be74ad431797d">
                                      <div class="ellipsis_box">
                                        <div class="ellipsis_box_start">f5ae27123be31d06ab8fc03eacb5732ae35f0838ebae53730a4be74ad43</div>
                                        <div class="ellipsis_box_end">1797d</div>
                                      </div>
                                    </a>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="ln2 it1 d-flex list-item-word it1">
                              <div class="tron-text-right tron-font-size-12px tron-color-gray-dark">
                                <div class="token_black table_pos">
                                  <div>9 secs ago</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="d-flex address-item">
                            <div class=" d-flex flex-column text-left">
                              <span class="d-flex ln1 it2">
                                <div class="tron-color-gray-dark transactionAddressTitle en" style="white-space: nowrap;">
                                  <span>From</span>
                                </div>
                                <span class="address-container address_max_width_home  ">
                                  <div class="react-contextmenu-wrapper">
                                    <span>
                                      <div class="truncate-ellipsis">
                                        <span>
                                          <div class="d-flex address-link-wrap " style="align-items: center;">
                                            <a class="text-truncate address-link " href="#/address/TLaGjwhvA8XQYSxFAcAXy7Dvuue9eGYitv">
                                              <span class="">
                                                <div class="ellipsis_box tag-background">
                                                  <div class="d-inline-block line-ellipsis">OKX Hot Wallet 8</div>
                                                </div>
                                              </span>
                                            </a>
                                            <div class="labelShow"></div>
                                          </div>
                                        </span>
                                      </div>
                                    </span>
                                  </div>
                                  <span class="new-address-content-menu-wrap">
                                    <nav role="menu" tabindex="-1" class="react-contextmenu dropdown-menu show new-address-content-menu" style="z-index: 899; position: fixed; opacity: 0; pointer-events: none;"></nav>
                                  </span>
                                </span>
                              </span>
                              <span class="d-flex ln2 it2 transactionToAddressWrapper" style="position: relative;">
                                <div class="tron-color-gray-dark transactionAddressTitle en" style="white-space: nowrap;">
                                  <span>To</span>
                                </div>
                                <span class="d-flex">
                                  <span class="address-container address_max_width_home  ">
                                    <div class="react-contextmenu-wrapper">
                                      <span>
                                        <div class="truncate-ellipsis">
                                          <span>
                                            <div class="d-flex address-link-wrap label-address-link-wrap" style="align-items: center;">
                                              <a class="text-truncate address-link tron-width-100 personal-address-link" href="#/contract/TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t/code">
                                                <div class="d-flex align-items-center">
                                                  <span class="flagIcon">
                                                    <svg class="icon tron-icon contract-icon" aria-hidden="true">
                                                      <use xlink:href="/static/media/icons.svg#icon-icon-sc"></use>
                                                    </svg>
                                                  </span>
                                                  <div class="ellipsis_box tag-background contract-content-width ">
                                                    <div class="d-inline-block line-ellipsis">USDT Token</div>
                                                  </div>
                                                </div>
                                              </a>
                                              <div class="labelShow"></div>
                                            </div>
                                          </span>
                                        </div>
                                      </span>
                                    </div>
                                    <span class="new-address-content-menu-wrap">
                                      <nav role="menu" tabindex="-1" class="react-contextmenu dropdown-menu show new-address-content-menu" style="z-index: 899; position: fixed; opacity: 0; pointer-events: none;"></nav>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </div>
                          </div>
                          <div class="transaction-type-box">
                            <div class="ln1 it3">
                              <div class="color-grey-200 d-flex it3" style="font-size: 14px;">
                                <span class="d-inline-block text-truncate" style="max-width: 90px;">
                                  <span class="tron-mr-2px">0</span>
                                </span>
                                <div>
                                  <div>
                                    <span>
                                      <a class="" href="#/token/0">TRX</a>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="ln2 d-flex flex-column transaction-type it3">
                              <div class="k-value-wrap">
                                <span class="k-value whitelist">Transfer</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item transactions-body list-group-item-en">
                      <div class="list-item-cont">
                        <div class="hash-body mb-0 d-flex">
                          <div class="d-flex flex-shrink-1 flex-grow-1 flex-column align-items-start hash-link-item">
                            <div class="ln1 it1 d-flex flex-grow-1 color-transfers-hash transaction-hash">
                              <div class="hash">
                                <div class="truncate-ellipsis">
                                  <span>
                                    <a class="color-tron-100 list-item-word" href="#/transaction/230727c36a2e6589797dd6a250c34d1cc54740569579d4568edbc64a04713f62">
                                      <div class="ellipsis_box">
                                        <div class="ellipsis_box_start">230727c36a2e6589797dd6a250c34d1cc54740569579d4568edbc64a047</div>
                                        <div class="ellipsis_box_end">13f62</div>
                                      </div>
                                    </a>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="ln2 it1 d-flex list-item-word it1">
                              <div class="tron-text-right tron-font-size-12px tron-color-gray-dark">
                                <div class="token_black table_pos">
                                  <div>9 secs ago</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="d-flex address-item">
                            <div class=" d-flex flex-column text-left">
                              <span class="d-flex ln1 it2">
                                <div class="tron-color-gray-dark transactionAddressTitle en" style="white-space: nowrap;">
                                  <span>From</span>
                                </div>
                                <span class="address-container address_max_width_home  ">
                                  <div class="react-contextmenu-wrapper">
                                    <span>
                                      <div class="truncate-ellipsis">
                                        <span>
                                          <div class="d-flex address-link-wrap " style="align-items: center;">
                                            <a class="text-truncate address-link " href="#/address/TJ7hhYhVhaxNx6BPyq7yFpqZrQULL3JSdb">
                                              <span class="">
                                                <div class="ellipsis_box tag-background">
                                                  <div class="d-inline-block line-ellipsis">Bitget 9</div>
                                                </div>
                                              </span>
                                            </a>
                                            <div class="labelShow"></div>
                                          </div>
                                        </span>
                                      </div>
                                    </span>
                                  </div>
                                  <span class="new-address-content-menu-wrap">
                                    <nav role="menu" tabindex="-1" class="react-contextmenu dropdown-menu show new-address-content-menu" style="z-index: 899; position: fixed; opacity: 0; pointer-events: none;"></nav>
                                  </span>
                                </span>
                              </span>
                              <span class="d-flex ln2 it2 transactionToAddressWrapper" style="position: relative;">
                                <div class="tron-color-gray-dark transactionAddressTitle en" style="white-space: nowrap;">
                                  <span>To</span>
                                </div>
                                <span class="address-container address_max_width_home  ">
                                  <div class="react-contextmenu-wrapper">
                                    <span>
                                      <div class="truncate-ellipsis">
                                        <span>
                                          <div class="d-flex address-link-wrap " style="align-items: center;">
                                            <a class="text-truncate address-link " href="#/address/TYFoNJofj562ditpeN7LZxpG8SMhbEmowL">
                                              <span class="">
                                                <div class="ellipsis_box ">
                                                  <div class="line-ellipsis">TYFoNJofj562ditpeN7LZxpG8SM</div>
                                                  <div>hbEmowL</div>
                                                </div>
                                              </span>
                                            </a>
                                            <div class="labelShow"></div>
                                          </div>
                                        </span>
                                      </div>
                                    </span>
                                  </div>
                                  <span class="new-address-content-menu-wrap">
                                    <nav role="menu" tabindex="-1" class="react-contextmenu dropdown-menu show new-address-content-menu" style="z-index: 899; position: fixed; opacity: 0; pointer-events: none;"></nav>
                                  </span>
                                </span>
                              </span>
                            </div>
                          </div>
                          <div class="transaction-type-box">
                            <div class="ln1 it3">
                              <div class="color-grey-200 d-flex it3" style="font-size: 14px;">
                                <span class="d-inline-block text-truncate" style="max-width: 90px;">
                                  <span class="tron-mr-2px">13.499883</span>
                                </span>
                                <div>
                                  <div>
                                    <span>
                                      <a class="" href="#/token/0">TRX</a>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="ln2 d-flex flex-column transaction-type it3">
                              <div class="k-value-wrap">
                                <span class="k-value whitelist">
                                  <span>Transfer TRX</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item transactions-body list-group-item-en">
                      <div class="list-item-cont">
                        <div class="hash-body mb-0 d-flex">
                          <div class="d-flex flex-shrink-1 flex-grow-1 flex-column align-items-start hash-link-item">
                            <div class="ln1 it1 d-flex flex-grow-1 color-transfers-hash transaction-hash">
                              <div class="hash">
                                <div class="truncate-ellipsis">
                                  <span>
                                    <a class="color-tron-100 list-item-word" href="#/transaction/8a3fc579bc9b548559bcff1b242fc11b34fd33cbd790b0408b97019be720cec5">
                                      <div class="ellipsis_box">
                                        <div class="ellipsis_box_start">8a3fc579bc9b548559bcff1b242fc11b34fd33cbd790b0408b97019be72</div>
                                        <div class="ellipsis_box_end">0cec5</div>
                                      </div>
                                    </a>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="ln2 it1 d-flex list-item-word it1">
                              <div class="tron-text-right tron-font-size-12px tron-color-gray-dark">
                                <div class="token_black table_pos">
                                  <div>9 secs ago</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="d-flex address-item">
                            <div class=" d-flex flex-column text-left">
                              <span class="d-flex ln1 it2">
                                <div class="tron-color-gray-dark transactionAddressTitle en" style="white-space: nowrap;">
                                  <span>From</span>
                                </div>
                                <span class="address-container address_max_width_home  ">
                                  <div class="react-contextmenu-wrapper">
                                    <span>
                                      <div class="truncate-ellipsis">
                                        <span>
                                          <div class="d-flex address-link-wrap " style="align-items: center;">
                                            <a class="text-truncate address-link " href="#/address/TNcWzh86Y1Y2LC4sAFY1ykTiQ2CjPaAmnR">
                                              <span class="">
                                                <div class="ellipsis_box ">
                                                  <div class="line-ellipsis">TNcWzh86Y1Y2LC4sAFY1ykTiQ2C</div>
                                                  <div>jPaAmnR</div>
                                                </div>
                                              </span>
                                            </a>
                                            <div class="labelShow"></div>
                                          </div>
                                        </span>
                                      </div>
                                    </span>
                                  </div>
                                  <span class="new-address-content-menu-wrap">
                                    <nav role="menu" tabindex="-1" class="react-contextmenu dropdown-menu show new-address-content-menu" style="z-index: 899; position: fixed; opacity: 0; pointer-events: none;"></nav>
                                  </span>
                                </span>
                              </span>
                              <span class="d-flex ln2 it2 transactionToAddressWrapper" style="position: relative;">
                                <div class="tron-color-gray-dark transactionAddressTitle en" style="white-space: nowrap;">
                                  <span>To</span>
                                </div>
                                <span class="address-container address_max_width_home  ">
                                  <div class="react-contextmenu-wrapper">
                                    <span>
                                      <div class="truncate-ellipsis">
                                        <span>
                                          <div class="d-flex address-link-wrap " style="align-items: center;">
                                            <a class="text-truncate address-link " href="#/address/TZ6ztHpSgZWGXLwgRMdwCMukHBgC7QpmE9">
                                              <span class="">
                                                <div class="ellipsis_box ">
                                                  <div class="line-ellipsis">TZ6ztHpSgZWGXLwgRMdwCMukHBg</div>
                                                  <div>C7QpmE9</div>
                                                </div>
                                              </span>
                                            </a>
                                            <div class="labelShow"></div>
                                          </div>
                                        </span>
                                      </div>
                                    </span>
                                  </div>
                                  <span class="new-address-content-menu-wrap">
                                    <nav role="menu" tabindex="-1" class="react-contextmenu dropdown-menu show new-address-content-menu" style="z-index: 899; position: fixed; opacity: 0; pointer-events: none;"></nav>
                                  </span>
                                </span>
                              </span>
                            </div>
                          </div>
                          <div class="transaction-type-box">
                            <div class="ln1 it3">
                              <div class="color-grey-200 d-flex it3" style="font-size: 14px;">
                                <span class="d-inline-block text-truncate" style="max-width: 90px;">
                                  <span class="tron-mr-2px">0.000001</span>
                                </span>
                                <div>
                                  <div>
                                    <span>
                                      <a class="" href="#/token/0">TRX</a>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="ln2 d-flex flex-column transaction-type it3">
                              <div class="k-value-wrap">
                                <span class="k-value whitelist">
                                  <span>Transfer TRX</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div class="home-view-link home-translations-view-link">
                    <a href="#/blockchain/transactions">More <svg class="icon tron-icon tron-font-size-8px" aria-hidden="true">
                        <use xlink:href="/static/media/icons.svg#icon-right-arrow"></use>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-44 home-translations-chart" style="display: none;">
                <div class="card-body pt-0">
                  <div style="min-width: 255px; height: auto; min-height: 250px;">
                    <div>
                      <div class="title-wrap">
                        <a href="#/data/charts/txn/daily-txn">Daily Transactions (14D)</a>
                      </div>
                      <div style="height: 302px;">
                        <div id="chartId_home_tronscation" class="echarts-dom-class" style="user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); position: relative;" _echarts_instance_="ec_1744372299507">
                          <div style="position: relative; width: 456px; height: 302px; padding: 0px; margin: 0px; border-width: 0px;">
                            <canvas data-zr-dom-id="zr_0" width="456" height="302" style="position: absolute; left: 0px; top: 0px; width: 456px; height: 302px; user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); padding: 0px; margin: 0px; border-width: 0px;"></canvas>
                          </div>
                          <div class="echart-tooltip-wrapper"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="transferBlockSec" style="padding-bottom: 0px;">
        <div class="container home-chart recent-tvl-panel">
          <div class="header d-flex">
            <span class="title-wrap">
              <span>Total Value Locked</span>
            </span>
            <span class="split-line">/</span>
            <span class="title-wrap-can-click">
              <span>Total Value on Chain</span>
            </span>
            <div class="tron-ml-auto d-flex align-items-center">
              <a class="entry-text" href="#/tools/contactUs?feedbackType=applyForInclusion">
                <span>
                  <span>Submit Project</span>
                </span>
              </a>
              <a class="more2" href="#/data/charts/defi/tvl">
                <span>
                  <span>More</span>
                </span>
                <svg class="icon tron-icon tron-font-size-8px tron-right-icon" aria-hidden="true">
                  <use xlink:href="/static/media/icons.svg#icon-right-arrow"></use>
                </svg>
              </a>
            </div>
          </div>
          <div class="content" style="">
            <div class="row-flex" style="">
              <div class="col-44 home-tvl-chart">
                <div class="card-body pt-0">
                  <div class="left-panel-bg">
                    <div style="min-width: 255px; height: auto;">
                      <div class="defi-title-wrap">
                        <div class="title-wrap">
                          <span class="title">
                            <span>Total Value Locked</span>
                          </span>
                          <span class="ml-1">
                            <div class="d-inline-block ">
                              <div class="question-mark">
                                <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                                  <use xlink:href="/static/media/icons.svg#icon-icon-ask"></use>
                                </svg>
                              </div>
                            </div>
                          </span>
                        </div>
                        <div class="amount">$ <span>19,240,135,935</span>
                        </div>
                      </div>
                      <div style="height: 308px;">
                        <div id="chartId_home_tvl" class="echarts-dom-class" style="user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); position: relative;" _echarts_instance_="ec_1744372299495">
                          <div style="position: relative; width: 456px; height: 308px; padding: 0px; margin: 0px; border-width: 0px;">
                            <canvas data-zr-dom-id="zr_0" width="456" height="308" style="position: absolute; left: 0px; top: 0px; width: 456px; height: 308px; user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); padding: 0px; margin: 0px; border-width: 0px;"></canvas>
                          </div>
                          <div class="echart-tooltip-wrapper"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-56 home-tvl-table">
                <div class="card ">
                  <div>
                    <div class="token_black defiTotalAmount table-tvl">
                      <div class="col-md-12 table_pos" style="padding: 0px;">
                        <div class="right-tvl-bg" style="height: 354px;">
                          <div class="smart-table-wrapper">
                            <div class="card table_pos ">
                              <div class="ant-table-wrapper">
                                <div class="ant-spin-nested-loading">
                                  <div class="ant-spin-container">
                                    <div class="ant-table ant-table-fixed-header">
                                      <div class="ant-table-container">
                                        <div class="ant-table-header" style="overflow: hidden;">
                                          <table style="table-layout: fixed;">
                                            <colgroup>
                                              <col style="width: 210px;">
                                              <col style="width: 180px;">
                                              <col style="width: 156px;">
                                              <col style="width: 150px;">
                                              <col style="width: 15px;">
                                            </colgroup>
                                            <thead class="ant-table-thead">
                                              <tr>
                                                <th class="ant-table-cell" scope="col" style="text-align: left;">Project</th>
                                                <th class="ant-table-cell" scope="col" style="text-align: left;">Category</th>
                                                <th aria-sort="descending" class="ant-table-cell ant-table-cell-ellipsis cell-max-125 ant-table-column-sort ant-table-column-has-sorters" tabindex="0" scope="col" style="text-align: right;">
                                                  <div class="ant-table-column-sorters">
                                                    <span class="ant-table-column-title">
                                                      <div>
                                                        <span class="mr-1">
                                                          <div class="d-inline-block ">
                                                            <div class="question-mark">
                                                              <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                                                                <use xlink:href="/static/media/icons.svg#icon-icon-ask"></use>
                                                              </svg>
                                                            </div>
                                                          </div>
                                                        </span>Total Value Locked
                                                      </div>
                                                    </span>
                                                    <span class="ant-table-column-sorter ant-table-column-sorter-full">
                                                      <span class="ant-table-column-sorter-inner" aria-hidden="true">
                                                        <span role="img" aria-label="caret-up" class="anticon anticon-caret-up ant-table-column-sorter-up">
                                                          <svg viewBox="0 0 1024 1024" focusable="false" data-icon="caret-up" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                                            <path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"></path>
                                                          </svg>
                                                        </span>
                                                        <span role="img" aria-label="caret-down" class="anticon anticon-caret-down ant-table-column-sorter-down active">
                                                          <svg viewBox="0 0 1024 1024" focusable="false" data-icon="caret-down" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                                            <path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"></path>
                                                          </svg>
                                                        </span>
                                                      </span>
                                                    </span>
                                                  </div>
                                                </th>
                                                <th aria-label="" class="ant-table-cell ant-table-cell-ellipsis cell-max-150 ant-table-column-has-sorters" tabindex="0" scope="col" style="text-align: right;">
                                                  <div class="ant-table-column-sorters">
                                                    <span class="ant-table-column-title">
                                                      <div>
                                                        <span class="mr-1">
                                                          <div class="d-inline-block ">
                                                            <div class="question-mark">
                                                              <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                                                                <use xlink:href="/static/media/icons.svg#icon-icon-ask"></use>
                                                              </svg>
                                                            </div>
                                                          </div>
                                                        </span>Change (24h)
                                                      </div>
                                                    </span>
                                                    <span class="ant-table-column-sorter ant-table-column-sorter-full">
                                                      <span class="ant-table-column-sorter-inner" aria-hidden="true">
                                                        <span role="img" aria-label="caret-up" class="anticon anticon-caret-up ant-table-column-sorter-up">
                                                          <svg viewBox="0 0 1024 1024" focusable="false" data-icon="caret-up" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                                            <path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"></path>
                                                          </svg>
                                                        </span>
                                                        <span role="img" aria-label="caret-down" class="anticon anticon-caret-down ant-table-column-sorter-down">
                                                          <svg viewBox="0 0 1024 1024" focusable="false" data-icon="caret-down" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                                            <path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"></path>
                                                          </svg>
                                                        </span>
                                                      </span>
                                                    </span>
                                                  </div>
                                                </th>
                                                <td class="ant-table-cell ant-table-cell-scrollbar"></td>
                                              </tr>
                                            </thead>
                                          </table>
                                        </div>
                                        <div class="ant-table-body" style="overflow-y: scroll; max-height: 316px;">
                                          <table style="table-layout: fixed;">
                                            <colgroup>
                                              <col style="width: 210px;">
                                              <col style="width: 180px;">
                                              <col style="width: 156px;">
                                              <col style="width: 150px;">
                                            </colgroup>
                                            <tbody class="ant-table-tbody">
                                              <tr aria-hidden="true" class="ant-table-measure-row" style="height: 0px; font-size: 0px;">
                                                <td style="padding: 0px; border: 0px; height: 0px;">
                                                  <div style="height: 0px; overflow: hidden;">&nbsp;</div>
                                                </td>
                                                <td style="padding: 0px; border: 0px; height: 0px;">
                                                  <div style="height: 0px; overflow: hidden;">&nbsp;</div>
                                                </td>
                                                <td style="padding: 0px; border: 0px; height: 0px;">
                                                  <div style="height: 0px; overflow: hidden;">&nbsp;</div>
                                                </td>
                                                <td style="padding: 0px; border: 0px; height: 0px;">
                                                  <div style="height: 0px; overflow: hidden;">&nbsp;</div>
                                                </td>
                                              </tr>
                                              <tr class="ant-table-row ant-table-row-level-0" data-row-key="0">
                                                <td class="ant-table-cell" style="text-align: left;">
                                                  <div class="d-flex align-items-center">
                                                    <a class="target_url" href="#!" target="_blank">
                                                      <b class="token-img-top">
                                                        <svg class="icon tron-icon tron-token-icon tron-mr-10px" aria-hidden="true">
                                                          <use xlink:href="/static/media/icons.svg#icon-icon-tron"></use>
                                                        </svg>
                                                      </b>
                                                      <span class="text-normal project-wid" style="color: inherit;">TRX Staking</span>
                                                    </a>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell" style="text-align: left;">
                                                  <div>
                                                    <div class="target_url">
                                                      <div class="defi-type">
                                                        <span class="defi-type-item">Governance</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell ant-table-cell-ellipsis cell-max-125 ant-table-column-sort" style="text-align: right;">
                                                  <div>
                                                    <div class="target_url">
                                                      <span class="text-normal">$ <span>10,274,546,856</span>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell ant-table-cell-ellipsis cell-max-150" style="text-align: right;">
                                                  <div>
                                                    <div class="target_url">
                                                      <span class="text-danger">-1.36%</span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr class="ant-table-row ant-table-row-level-0" data-row-key="1">
                                                <td class="ant-table-cell" style="text-align: left;">
                                                  <div class="d-flex align-items-center">
                                                    <a class="target_url" href="#!" target="_blank">
                                                      <b class="token-img-top">
                                                        <svg class="icon tron-icon tron-token-icon tron-mr-10px" aria-hidden="true">
                                                          <use xlink:href="/static/media/icons.svg#icon-icon-justlend"></use>
                                                        </svg>
                                                      </b>
                                                      <span class="text-normal project-wid" style="color: inherit;">JustLend DAO</span>
                                                    </a>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell" style="text-align: left;">
                                                  <div>
                                                    <div class="target_url">
                                                      <div class="defi-type">
                                                        <span class="defi-type-item">Lending</span>
                                                        <span class="defi-type-item">Staking</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell ant-table-cell-ellipsis cell-max-125 ant-table-column-sort" style="text-align: right;">
                                                  <div>
                                                    <div class="target_url">
                                                      <span class="text-normal">$ <span>5,615,950,190</span>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell ant-table-cell-ellipsis cell-max-150" style="text-align: right;">
                                                  <div>
                                                    <div class="target_url">
                                                      <span class="text-danger">-1.26%</span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr class="ant-table-row ant-table-row-level-0" data-row-key="2">
                                                <td class="ant-table-cell" style="text-align: left;">
                                                  <div class="d-flex align-items-center">
                                                    <a class="target_url" href="#!" target="_blank">
                                                      <b class="token-img-top">
                                                        <svg class="icon tron-icon tron-token-icon tron-mr-10px tron-token-color" aria-hidden="true">
                                                          <use xlink:href="/static/media/icons.svg#icon-icon-jst"></use>
                                                        </svg>
                                                      </b>
                                                      <span class="text-normal project-wid" style="color: inherit;">Just Cryptos</span>
                                                    </a>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell" style="text-align: left;">
                                                  <div>
                                                    <div class="target_url">
                                                      <div class="defi-type">
                                                        <span class="defi-type-item">Cross Chain</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell ant-table-cell-ellipsis cell-max-125 ant-table-column-sort" style="text-align: right;">
                                                  <div>
                                                    <div class="target_url">
                                                      <span class="text-normal">$ <span>2,303,437,578</span>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell ant-table-cell-ellipsis cell-max-150" style="text-align: right;">
                                                  <div>
                                                    <div class="target_url">
                                                      <span class="text-danger">-0.02%</span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr class="ant-table-row ant-table-row-level-0" data-row-key="3">
                                                <td class="ant-table-cell" style="text-align: left;">
                                                  <div class="d-flex align-items-center">
                                                    <a class="target_url" href="#!" target="_blank">
                                                      <b class="token-img-top">
                                                        <svg class="icon tron-icon tron-token-icon tron-mr-10px" aria-hidden="true">
                                                          <use xlink:href="/static/media/icons.svg#icon-icon-sun"></use>
                                                        </svg>
                                                      </b>
                                                      <span class="text-normal project-wid" style="color: inherit;">SUN.io</span>
                                                    </a>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell" style="text-align: left;">
                                                  <div>
                                                    <div class="target_url">
                                                      <div class="defi-type">
                                                        <span class="defi-type-item">DEX</span>
                                                        <span class="defi-type-item">Stablecoin</span>
                                                        <span class="defi-type-item">Farm</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell ant-table-cell-ellipsis cell-max-125 ant-table-column-sort" style="text-align: right;">
                                                  <div>
                                                    <div class="target_url">
                                                      <span class="text-normal">$ <span>643,537,276</span>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell ant-table-cell-ellipsis cell-max-150" style="text-align: right;">
                                                  <div>
                                                    <div class="target_url">
                                                      <span class="text-danger">-1.05%</span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr class="ant-table-row ant-table-row-level-0" data-row-key="4">
                                                <td class="ant-table-cell" style="text-align: left;">
                                                  <div class="d-flex align-items-center">
                                                    <a class="target_url" href="#!" target="_blank">
                                                      <b class="token-img-top">
                                                        <img width="20" height="20" src="https://static.tronscan.org/production/upload/logo/TPYmHEhy5n8TCEfYGqW2rPxsghSfzghPDn.png" alt="" style="margin-right: 10px;">
                                                      </b>
                                                      <span class="text-normal project-wid" style="color: inherit;">USDD</span>
                                                    </a>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell" style="text-align: left;">
                                                  <div>
                                                    <div class="target_url">
                                                      <div class="defi-type">
                                                        <span class="defi-type-item">Stablecoin</span>
                                                        <span class="defi-type-item">Lending</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell ant-table-cell-ellipsis cell-max-125 ant-table-column-sort" style="text-align: right;">
                                                  <div>
                                                    <div class="target_url">
                                                      <span class="text-normal">$ <span>327,933,864</span>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell ant-table-cell-ellipsis cell-max-150" style="text-align: right;">
                                                  <div>
                                                    <div class="target_url">
                                                      <span class="text-danger">-0.40%</span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr class="ant-table-row ant-table-row-level-0" data-row-key="5">
                                                <td class="ant-table-cell" style="text-align: left;">
                                                  <div class="d-flex align-items-center">
                                                    <a class="target_url" href="#!" target="_blank">
                                                      <b class="token-img-top">
                                                        <img width="20" height="20" src="https://static.tronscan.org/production/upload/logo/new/stUSDT_logo.png" alt="" style="margin-right: 10px;">
                                                      </b>
                                                      <span class="text-normal project-wid" style="color: inherit;">Staked USDT</span>
                                                    </a>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell" style="text-align: left;">
                                                  <div>
                                                    <div class="target_url">
                                                      <div class="defi-type">
                                                        <span class="defi-type-item">RWA</span>
                                                        <span class="defi-type-item">Staking</span>
                                                        <span class="defi-type-item">Yield</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell ant-table-cell-ellipsis cell-max-125 ant-table-column-sort" style="text-align: right;">
                                                  <div>
                                                    <div class="target_url">
                                                      <span class="text-normal">$ <span>55,195,745</span>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell ant-table-cell-ellipsis cell-max-150" style="text-align: right;">
                                                  <div>
                                                    <div class="target_url">
                                                      <span class="text-success">+0.01%</span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr class="ant-table-row ant-table-row-level-0" data-row-key="6">
                                                <td class="ant-table-cell" style="text-align: left;">
                                                  <div class="d-flex align-items-center">
                                                    <a class="target_url" href="#!" target="_blank">
                                                      <b class="token-img-top">
                                                        <svg class="icon tron-icon tron-token-icon tron-mr-10px tron-stable-style" aria-hidden="true">
                                                          <use xlink:href="/static/media/icons.svg#icon-icon-just1"></use>
                                                        </svg>
                                                      </b>
                                                      <span class="text-normal project-wid" style="color: inherit;">JustStable</span>
                                                    </a>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell" style="text-align: left;">
                                                  <div>
                                                    <div class="target_url">
                                                      <div class="defi-type">
                                                        <span class="defi-type-item">Stablecoin</span>
                                                        <span class="defi-type-item">Lending</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell ant-table-cell-ellipsis cell-max-125 ant-table-column-sort" style="text-align: right;">
                                                  <div>
                                                    <div class="target_url">
                                                      <span class="text-normal">$ <span>29,395,656</span>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell ant-table-cell-ellipsis cell-max-150" style="text-align: right;">
                                                  <div>
                                                    <div class="target_url">
                                                      <span class="text-danger">-1.69%</span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr class="ant-table-row ant-table-row-level-0" data-row-key="7">
                                                <td class="ant-table-cell" style="text-align: left;">
                                                  <div class="d-flex align-items-center">
                                                    <a class="target_url" href="#!" target="_blank">
                                                      <b class="token-img-top">
                                                        <svg class="icon tron-icon tron-token-icon tron-mr-10px" aria-hidden="true">
                                                          <use xlink:href="/static/media/icons.svg#icon-icon-btt"></use>
                                                        </svg>
                                                      </b>
                                                      <span class="text-normal project-wid" style="color: inherit;">BTT Staking Governance</span>
                                                    </a>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell" style="text-align: left;">
                                                  <div>
                                                    <div class="target_url">
                                                      <div class="defi-type">
                                                        <span class="defi-type-item">Governance</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell ant-table-cell-ellipsis cell-max-125 ant-table-column-sort" style="text-align: right;">
                                                  <div>
                                                    <div class="target_url">
                                                      <span class="text-normal">$ <span>27,137,635</span>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td class="ant-table-cell ant-table-cell-ellipsis cell-max-150" style="text-align: right;">
                                                  <div>
                                                    <div class="target_url">
                                                      <span class="text-danger">-1.67%</span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="transferBlockSec" style="padding-bottom: 0px;">
        <div class="container home-chart top-transfer-tokens">
          <div class="header d-flex">
            <a href="#/blockchain/transfers">
              <span class="tron-font-default-color">
                <span>Top 5 Tokens by Transfer Volume</span>
              </span>
            </a>
          </div>
          <div class="content" style="">
            <div class="col-56 home-transfer-token-table">
              <div class="card">
                <div class="token_black">
                  <div class="col-md-12 table_pos" style="padding: 0px;">
                    <div class="right-tvl-bg">
                      <div class="smart-table-wrapper">
                        <div class="card table_pos ">
                          <div class="ant-table-wrapper">
                            <div class="ant-spin-nested-loading">
                              <div class="ant-spin-container">
                                <div class="ant-table">
                                  <div class="ant-table-container">
                                    <div class="ant-table-content">
                                      <table style="table-layout: auto;">
                                        <colgroup></colgroup>
                                        <thead class="ant-table-thead">
                                          <tr>
                                            <th class="ant-table-cell" scope="col" style="text-align: center;">#</th>
                                            <th class="ant-table-cell" scope="col" style="text-align: left;">Token</th>
                                            <th aria-sort="descending" class="ant-table-cell ant-table-column-sort ant-table-column-has-sorters" tabindex="0" scope="col" style="text-align: right;">
                                              <div class="ant-table-column-sorters">
                                                <span class="ant-table-column-title">
                                                  <div class="d-flex align-items-center justify-content-end">
                                                    <span class="d-flex mr-1">
                                                      <div class="d-inline-block ">
                                                        <div class="question-mark">
                                                          <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                                                            <use xlink:href="/static/media/icons.svg#icon-icon-ask"></use>
                                                          </svg>
                                                        </div>
                                                      </div>
                                                    </span>
                                                    <div class="text-left tron-line-height-16px th-word-break" style="width: 102px;">Transfer Volume (Yesterday)</div>
                                                  </div>
                                                </span>
                                                <span class="ant-table-column-sorter">
                                                  <span class="ant-table-column-sorter-inner" aria-hidden="true">
                                                    <span role="img" aria-label="caret-down" class="anticon anticon-caret-down ant-table-column-sorter-down active">
                                                      <svg viewBox="0 0 1024 1024" focusable="false" data-icon="caret-down" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                                        <path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"></path>
                                                      </svg>
                                                    </span>
                                                  </span>
                                                </span>
                                              </div>
                                            </th>
                                            <th class="ant-table-cell ant-table-cell-ellipsis" scope="col" style="text-align: right;">
                                              <div class="d-flex align-items-center justify-content-end">
                                                <span class="d-flex mr-1">
                                                  <div class="d-inline-block ">
                                                    <div class="question-mark">
                                                      <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                                                        <use xlink:href="/static/media/icons.svg#icon-icon-ask"></use>
                                                      </svg>
                                                    </div>
                                                  </div>
                                                </span>
                                                <div class="text-left tron-line-height-16px th-word-break" style="width: 72px;">Transfers (Yesterday)</div>
                                              </div>
                                            </th>
                                            <th class="ant-table-cell ant-table-cell-ellipsis" scope="col" style="text-align: right;">
                                              <span>Market Cap</span>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody class="ant-table-tbody">
                                          <tr class="ant-table-row ant-table-row-level-0" data-row-key="tableKey0">
                                            <td class="ant-table-cell" style="text-align: center;">
                                              <span class="rankWidth">
                                                <span class="rank-0 rank"></span>
                                              </span>
                                            </td>
                                            <td class="ant-table-cell" style="text-align: left;">
                                              <div class="table-imgtext">
                                                <div class="d-flex align-items-center">
                                                  <div class="token-wrap">
                                                    <a class="" href="#/token20/TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t">
                                                      <span class="token-name d-flex align-items-center">
                                                        <div style="width: 20px; height: 20px; margin-right: 10px;">
                                                          <div class="token-img-top d-flex align-items-center">
                                                            <svg class="icon tron-icon tron-token-icon" aria-hidden="true">
                                                              <use xlink:href="/static/media/icons.svg#icon-icon-usdt"></use>
                                                            </svg>
                                                            <svg class="icon tron-icon tron-v-icon" aria-hidden="true">
                                                              <use xlink:href="/static/media/icons.svg#icon-icon-v"></use>
                                                            </svg>
                                                          </div>
                                                        </div>
                                                        <div>
                                                          <div class="white-space-nowrap">Tether USD</div>
                                                          <div class="token-abbr">USDT</div>
                                                        </div>
                                                      </span>
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                            <td class="ant-table-cell ant-table-column-sort" style="text-align: right;">
                                              <div class="d-flex flex-column">
                                                <span>$ <span>22,918,746,014</span>
                                                </span>
                                              </div>
                                            </td>
                                            <td class="ant-table-cell ant-table-cell-ellipsis" style="text-align: right;">
                                              <span>2,405,769</span>
                                            </td>
                                            <td class="ant-table-cell ant-table-cell-ellipsis" style="text-align: right;">
                                              <div class="d-flex flex-column">
                                                <span>$ <span>67,682,419,565</span>
                                                </span>
                                              </div>
                                            </td>
                                          </tr>
                                          <tr class="ant-table-row ant-table-row-level-0" data-row-key="tableKey1">
                                            <td class="ant-table-cell" style="text-align: center;">
                                              <span class="rankWidth">
                                                <span class="rank-1 rank"></span>
                                              </span>
                                            </td>
                                            <td class="ant-table-cell" style="text-align: left;">
                                              <div class="table-imgtext">
                                                <div class="d-flex align-items-center">
                                                  <div class="token-wrap">
                                                    <a class="" href="#/token/0">
                                                      <span class="token-name d-flex align-items-center">
                                                        <div style="width: 20px; height: 20px; margin-right: 10px;">
                                                          <div class="token-img-top d-flex align-items-center">
                                                            <svg class="icon tron-icon tron-token-icon" aria-hidden="true">
                                                              <use xlink:href="/static/media/icons.svg#icon-icon-tron"></use>
                                                            </svg>
                                                            <svg class="icon tron-icon tron-v-icon" aria-hidden="true">
                                                              <use xlink:href="/static/media/icons.svg#icon-icon-v"></use>
                                                            </svg>
                                                          </div>
                                                        </div>
                                                        <div>
                                                          <div class="white-space-nowrap">TRX</div>
                                                          <div class="token-abbr">TRON</div>
                                                        </div>
                                                      </span>
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                            <td class="ant-table-cell ant-table-column-sort" style="text-align: right;">
                                              <div class="d-flex flex-column">
                                                <span>$ <span>257,288,883</span>
                                                </span>
                                              </div>
                                            </td>
                                            <td class="ant-table-cell ant-table-cell-ellipsis" style="text-align: right;">
                                              <span>3,928,519</span>
                                            </td>
                                            <td class="ant-table-cell ant-table-cell-ellipsis" style="text-align: right;">
                                              <div class="d-flex flex-column">
                                                <span>$ <span>22,528,773,811</span>
                                                </span>
                                              </div>
                                            </td>
                                          </tr>
                                          <tr class="ant-table-row ant-table-row-level-0" data-row-key="tableKey2">
                                            <td class="ant-table-cell" style="text-align: center;">
                                              <span class="rankWidth">
                                                <span class="rank-2 rank"></span>
                                              </span>
                                            </td>
                                            <td class="ant-table-cell" style="text-align: left;">
                                              <div class="table-imgtext">
                                                <div class="d-flex align-items-center">
                                                  <div class="token-wrap">
                                                    <a class="" href="#/token20/TXDk8mbtRbXeYuMNS83CfKPaYYT8XWv9Hz">
                                                      <span class="token-name d-flex align-items-center">
                                                        <div style="width: 20px; height: 20px; margin-right: 10px;">
                                                          <div class="token-img-top d-flex align-items-center">
                                                            <img src="https://static.tronscan.org/production/upload/logo/new/TXDk8mbtRbXeYuMNS83CfKPaYYT8XWv9Hz.png" loading="lazy" alt="" style="width: 20px; height: 20px;">
                                                            <svg class="icon tron-icon tron-v-icon" aria-hidden="true">
                                                              <use xlink:href="/static/media/icons.svg#icon-icon-v"></use>
                                                            </svg>
                                                          </div>
                                                        </div>
                                                        <div>
                                                          <div class="white-space-nowrap">Decentralized USD</div>
                                                          <div class="token-abbr">USDD</div>
                                                        </div>
                                                      </span>
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                            <td class="ant-table-cell ant-table-column-sort" style="text-align: right;">
                                              <div class="d-flex flex-column">
                                                <span>$ <span>107,240,244</span>
                                                </span>
                                              </div>
                                            </td>
                                            <td class="ant-table-cell ant-table-cell-ellipsis" style="text-align: right;">
                                              <span>7,601</span>
                                            </td>
                                            <td class="ant-table-cell ant-table-cell-ellipsis" style="text-align: right;">
                                              <div class="d-flex flex-column">
                                                <span>$ <span>301,898,739</span>
                                                </span>
                                              </div>
                                            </td>
                                          </tr>
                                          <tr class="ant-table-row ant-table-row-level-0" data-row-key="tableKey3">
                                            <td class="ant-table-cell" style="text-align: center;">
                                              <span class="rankWidth">4</span>
                                            </td>
                                            <td class="ant-table-cell" style="text-align: left;">
                                              <div class="table-imgtext">
                                                <div class="d-flex align-items-center">
                                                  <div class="token-wrap">
                                                    <a class="" href="#/token20/TQYuR8FpmhMJK3ZpfoTgERjaZRywqMnFAH">
                                                      <span class="token-name d-flex align-items-center">
                                                        <div style="width: 20px; height: 20px; margin-right: 10px;">
                                                          <div class="token-img-top d-flex align-items-center">
                                                            <img src="https://static.tronscan.org/production/upload/logo/new/TQYuR8FpmhMJK3ZpfoTgERjaZRywqMnFAH.png?t=1660129029358" loading="lazy" alt="" style="width: 20px; height: 20px;">
                                                          </div>
                                                        </div>
                                                        <div>
                                                          <div class="white-space-nowrap">PayNet Coin</div>
                                                          <div class="token-abbr">PAYN</div>
                                                        </div>
                                                      </span>
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                            <td class="ant-table-cell ant-table-column-sort" style="text-align: right;">
                                              <div class="d-flex flex-column">
                                                <span>$ <span>25,390,738</span>
                                                </span>
                                              </div>
                                            </td>
                                            <td class="ant-table-cell ant-table-cell-ellipsis" style="text-align: right;">
                                              <span>13,098</span>
                                            </td>
                                            <td class="ant-table-cell ant-table-cell-ellipsis" style="text-align: right;">
                                              <div class="d-flex flex-column">
                                                <span>$ <span>350,826,985</span>
                                                </span>
                                              </div>
                                            </td>
                                          </tr>
                                          <tr class="ant-table-row ant-table-row-level-0" data-row-key="tableKey4">
                                            <td class="ant-table-cell" style="text-align: center;">
                                              <span class="rankWidth">5</span>
                                            </td>
                                            <td class="ant-table-cell" style="text-align: left;">
                                              <div class="table-imgtext">
                                                <div class="d-flex align-items-center">
                                                  <div class="token-wrap">
                                                    <a class="" href="#/token20/TPYmHEhy5n8TCEfYGqW2rPxsghSfzghPDn">
                                                      <span class="token-name d-flex align-items-center">
                                                        <div style="width: 20px; height: 20px; margin-right: 10px;">
                                                          <div class="token-img-top d-flex align-items-center">
                                                            <svg class="icon tron-icon tron-token-icon" aria-hidden="true">
                                                              <use xlink:href="/static/media/icons.svg#icon-icon-usdd"></use>
                                                            </svg>
                                                            <svg class="icon tron-icon tron-v-icon" aria-hidden="true">
                                                              <use xlink:href="/static/media/icons.svg#icon-icon-v"></use>
                                                            </svg>
                                                          </div>
                                                        </div>
                                                        <div>
                                                          <div class="white-space-nowrap">Decentralized USDOLD</div>
                                                          <div class="token-abbr">USDDOLD</div>
                                                        </div>
                                                      </span>
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                            <td class="ant-table-cell ant-table-column-sort" style="text-align: right;">
                                              <div class="d-flex flex-column">
                                                <span>$ <span>20,068,618</span>
                                                </span>
                                              </div>
                                            </td>
                                            <td class="ant-table-cell ant-table-cell-ellipsis" style="text-align: right;">
                                              <span>708</span>
                                            </td>
                                            <td class="ant-table-cell ant-table-cell-ellipsis" style="text-align: right;">
                                              <div class="d-flex flex-column">
                                                <span>$ <span>29,231,676</span>
                                                </span>
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-44 home-transfer-token-chart">
              <div class="card-body pt-0">
                <div class="left-panel-bg" style="padding-top: 20px;">
                  <div class="title-wrap">
                    <span class="title">
                      <span>Transfer Volume Trends (14D)</span>
                    </span>
                  </div>
                  <div id="chartId_home_top_transfer_tokens" class="undefined echarts-wrapper" style="height: 309px; user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); position: relative;" _echarts_instance_="ec_1744372299493">
                    <div style="position: relative; width: 446px; height: 309px; padding: 0px; margin: 0px; border-width: 0px;">
                      <canvas data-zr-dom-id="zr_0" width="446" height="309" style="position: absolute; left: 0px; top: 0px; width: 446px; height: 309px; user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); padding: 0px; margin: 0px; border-width: 0px;"></canvas>
                    </div>
                    <div class="echart-tooltip-wrapper"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="transferBlockSec" style="padding-bottom: 5px;">
        <div class="container home-chart tron-usdt-panel">
          <div class="header d-flex ">
            <a class="title-wrap" href="#/data/analytics/stablecoin/usdt">TRON USDT</a>
          </div>
          <div class="content" style="border-radius: 6px; overflow: hidden;">
            <div class="row-flex">
              <div class="col-56 home-stablecoin-table">
                <div class="tronusdt">
                  <section class="charts ">
                    <div class="tron-usdt-chart-wrapper">
                      <div class="usdt-chart-header">
                        <div class="d-flex align-items-center tableTitleListWrap">
                          <div class="tableTitleList">
                            <span class="active-title title">
                              <span>Transfer</span>
                            </span>
                            <span class="divide-line">/</span>
                          </div>
                          <div class="tableTitleList">
                            <span class="title">
                              <span>Total Supply</span>
                            </span>
                            <span class="divide-line">/</span>
                          </div>
                          <div class="tableTitleList">
                            <span class="title">
                              <span>Accounts</span>
                            </span>
                          </div>
                        </div>
                        <div class="chart-date-wrapper">
                          <div class="chart-date-item chart-date-item-active">
                            <span>1M</span>
                          </div>
                          <div class="chart-date-item ">
                            <span>3M</span>
                          </div>
                        </div>
                      </div>
                      <div id="homeUsdtTransferChart_0_2041778204728194" class="tron-usdt-chart echarts-wrapper" style="height: 350px; user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); position: relative;" _echarts_instance_="ec_1744372299498">
                        <div style="position: relative; width: 606px; height: 350px; padding: 0px; margin: 0px; border-width: 0px;">
                          <canvas data-zr-dom-id="zr_0" width="606" height="350" style="position: absolute; left: 0px; top: 0px; width: 606px; height: 350px; user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); padding: 0px; margin: 0px; border-width: 0px;"></canvas>
                          <canvas data-zr-dom-id="zr_1" width="606" height="350" style="position: absolute; left: 0px; top: 0px; width: 606px; height: 350px; user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); padding: 0px; margin: 0px; border-width: 0px;"></canvas>
                        </div>
                        <div class="echart-tooltip-wrapper"></div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
              <div class="col-44 home-stablecoin-chart">
                <section class="usdt-info-overview">
                  <section class="overview-list">
                    <h4>
                      <span>Transfer</span>
                    </h4>
                    <div class="totalInfo">
                      <span class="totalInfoEn">7-day transfer volume reaches <span class="countInfo">$143,707,305,336</span>, changed by <span class="perchange tron-ml-4px tron-fron-success-dark-color">+0.2791%</span>
                      </span>
                    </div>
                    <div class="changeInfo">
                      <span>7-day transfers reach <span>15,859,520</span>, changed by <span class="perchange tron-fron-success-dark-color">+0.5207%</span>
                      </span>
                    </div>
                  </section>
                  <section class="overview-list">
                    <h4>
                      <span>Total Supply</span>
                    </h4>
                    <div class="totalInfo">
                      <span class="totalInfoEn">The total supply of USDT on TRON is <span class="countInfo">67,717,169,531</span>
                      </span>
                    </div>
                    <div class="changeInfo">
                      <span>Changed by <span class="tron-fron-success-dark-color">+0.0625%</span> comparing to 30 days ago </span>
                    </div>
                  </section>
                  <section class="overview-list">
                    <h4>
                      <span>Accounts</span>
                    </h4>
                    <div class="totalInfo">
                      <span class="totalInfoEn">
                        <span class="countInfo">63,954,115</span> holders, changed by <span class="perchange tron-ml-4px tron-fron-success-dark-color">+2.4004%</span> comparing to 30 days ago </span>
                    </div>
                    <div class="changeInfo">
                      <span>
                        <span>1,134,084</span> active accounts for yesterday, changed by <span class="perchange tron-fron-success-dark-color">+1.2264%</span> comparing to 30 days ago </span>
                    </div>
                  </section>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="transferBlockSec" style="padding-bottom: 0px;">
        <div class="container home-chart home-statistics">
          <div class="header d-flex">
            <a class="title-wrap" href="#/data/charts">
              <span>Charts</span>
            </a>
          </div>
          <div class="content">
            <div class="home-accounts">
              <div class="title-container">
                <span class="active-title title">Active Accounts</span>
                <span class="divide-line">/</span>
                <span class="title">New Accounts</span>
                <span class="divide-line">/</span>
                <span class="title">Total Accounts</span>
                <div class="d-flex align-items-center ">
                  <div class="ant-dropdown-trigger camera-icon">
                    <svg class="icon tron-icon tron-icon-camera false" aria-hidden="true">
                      <use xlink:href="/static/media/icons.svg#icon-icon-xiazaitupian"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="home-account-chart d-flex align-items-center justify-content-center" style="height: 224px;">
                <div id="chartId_home_accounts" class="echarts-dom-class" style="user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); position: relative;" _echarts_instance_="ec_1744372299496">
                  <div style="position: relative; width: 517px; height: 224px; padding: 0px; margin: 0px; border-width: 0px;">
                    <canvas data-zr-dom-id="zr_0" width="517" height="224" style="position: absolute; left: 0px; top: 0px; width: 517px; height: 224px; user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); padding: 0px; margin: 0px; border-width: 0px;"></canvas>
                  </div>
                  <div class="echart-tooltip-wrapper"></div>
                </div>
              </div>
              <div class="gap-row-line"></div>
              <div class="recent-data">
                <ul>
                  <li>
                    <h2 class="indicators">Active Accounts (Yesterday)</h2>
                    <div class="indicators-content">
                      <span class="indicators-data">3,097,330</span>
                      <span class="indicators-percent">
                        <span class="growth"> +0.43%</span>
                      </span>
                    </div>
                  </li>
                  <li>
                    <h2 class="indicators">Average Active Accounts (Past 1 month)</h2>
                    <div class="indicators-content">
                      <span class="indicators-data">2,964,518</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="home-protocol-income">
              <div class="title-container">
                <span class="active-title title">Total Protocol Revenue</span>
                <div class="d-flex align-items-center ">
                  <div class="ant-dropdown-trigger camera-icon">
                    <svg class="icon tron-icon tron-icon-camera false" aria-hidden="true">
                      <use xlink:href="/static/media/icons.svg#icon-icon-xiazaitupian"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="home-protocol-chart d-flex align-items-center justify-content-center" style="height: 224px;">
                <div id="chartId_home_protocol_revenue" class="echarts-dom-class" style="user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); position: relative;" _echarts_instance_="ec_1744372299499">
                  <div style="position: relative; width: 528px; height: 224px; padding: 0px; margin: 0px; border-width: 0px;">
                    <canvas data-zr-dom-id="zr_0" width="528" height="224" style="position: absolute; left: 0px; top: 0px; width: 528px; height: 224px; user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); padding: 0px; margin: 0px; border-width: 0px;"></canvas>
                  </div>
                  <div class="echart-tooltip-wrapper"></div>
                </div>
              </div>
              <div class="gap-row-line"></div>
              <div class="recent-data">
                <ul>
                  <li>
                    <h2 class="indicators">Total Protocol Revenue (Yesterday)</h2>
                    <div class="indicators-content">
                      <span class="indicators-data">$10,459,796</span>
                      <span class="indicators-percent">
                        <span class="reduce"> -2.35%</span>
                      </span>
                    </div>
                  </li>
                  <li>
                    <h2 class="indicators">Total Protocol Revenue (Past 1 month)</h2>
                    <div class="indicators-content">
                      <span class="indicators-data">$279,995,006</span>
                      <span class="indicators-percent">
                        <span class="growth"> +1.28%</span>
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container trx-charts-wrap">
        <div class="home-supply-wrap">
          <div class="home-supply-container">
            <div class="home-supply-title">
              <div class="home-supply-title-left">
                <div class="home-supply-title-text active">TRX Supply</div>
                <div class="home-supply-title-split">/</div>
                <div class="home-supply-title-text false">TRX Net Increase</div>
                <div class="d-flex align-items-center ">
                  <div class="ant-dropdown-trigger camera-icon">
                    <svg class="icon tron-icon tron-icon-camera false" aria-hidden="true">
                      <use xlink:href="/static/media/icons.svg#icon-icon-xiazaitupian"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="home-supply-title-right">
                <div class="home-supply-title-btns">
                  <div class="home-supply-title-btn active">14D</div>
                  <div class="home-supply-title-btn false">1M</div>
                  <div class="home-supply-title-btn false">6M</div>
                </div>
              </div>
            </div>
            <div class="home-supply-chart">
              <div style="height: 218px;">
                <div id="chart_home_trx_supply" class="echarts-dom-class" style="user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); position: relative;" _echarts_instance_="ec_1744372299501">
                  <div style="position: relative; width: 530px; height: 218px; padding: 0px; margin: 0px; border-width: 0px;">
                    <canvas data-zr-dom-id="zr_0" width="530" height="218" style="position: absolute; left: 0px; top: 0px; width: 530px; height: 218px; user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); padding: 0px; margin: 0px; border-width: 0px;"></canvas>
                  </div>
                  <div class="echart-tooltip-wrapper"></div>
                </div>
              </div>
            </div>
            <div class="gap-row-line"></div>
            <div class="home-supply-footer">
              <div class="home-supply-overview">
                <div class="home-supply-overview-title">Total Supply</div>
                <div class="home-supply-overview-data">
                  <span class="home-supply-overview-data-num">94,963,009,794</span>
                  <span class="home-supply-overview-data-tag"></span>
                </div>
              </div>
              <div class="home-supply-overview">
                <div class="home-supply-overview-title">Annualized Inflation Rate <div class="d-inline-block ">
                    <div class="question-mark">
                      <svg class="icon tron-icon question-mark-icon" aria-hidden="true">
                        <use xlink:href="/static/media/icons.svg#icon-icon-ask"></use>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="home-supply-overview-data">
                  <span class="home-supply-overview-data-num">
                    <span class="reduce"> -0.90%</span>
                    <span class="indicators-desc">Deflation</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="home-supply-wrap">
          <div class="home-staked-container">
            <div class="home-staked-title">
              <div class="home-staked-title-left">
                <div class="home-staked-title-text active">TRX Staked</div>
                <div class="home-staked-title-split">/</div>
                <div class="home-staked-title-text false">TRX Staking Rate</div>
                <div class="d-flex align-items-center ">
                  <div class="ant-dropdown-trigger camera-icon">
                    <svg class="icon tron-icon tron-icon-camera false" aria-hidden="true">
                      <use xlink:href="/static/media/icons.svg#icon-icon-xiazaitupian"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="home-staked-title-right">
                <div class="home-staked-title-legend ">
                  <span class="home-staked-title-legend-circle home-staked-title-legend-circle-blue"></span>Stake 2.0
                </div>
                <div class="home-staked-title-legend ">
                  <span class="home-staked-title-legend-circle home-staked-title-legend-circle-red "></span>Stake 1.0
                </div>
              </div>
            </div>
            <div class="home-staked-chart">
              <div style="height: 224px;">
                <div id="chart_home_trx_staked" class="echarts-dom-class" style="user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); position: relative;" _echarts_instance_="ec_1744372299497">
                  <div style="position: relative; width: 530px; height: 224px; padding: 0px; margin: 0px; border-width: 0px;">
                    <canvas data-zr-dom-id="zr_0" width="530" height="224" style="position: absolute; left: 0px; top: 0px; width: 530px; height: 224px; user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); padding: 0px; margin: 0px; border-width: 0px;"></canvas>
                  </div>
                  <div class="echart-tooltip-wrapper"></div>
                </div>
              </div>
            </div>
            <div class="gap-row-line"></div>
            <div class="home-staked-footer">
              <div class="home-staked-overview">
                <div class="home-staked-overview-title">Total Staked</div>
                <div class="home-staked-overview-data">
                  <span class="home-staked-overview-data-num">43,158,242,314</span>
                </div>
              </div>
              <div class="home-staked-overview">
                <div class="home-staked-overview-title">Stake 2.0</div>
                <div class="home-staked-overview-data">
                  <span class="home-staked-overview-data-num">23,342,979,152</span>
                  <span class="home-staked-overview-data-tag">
                    <span style="color: rgb(115, 120, 123);">(54.09%)</span>
                  </span>
                </div>
              </div>
              <div class="home-staked-overview">
                <div class="home-staked-overview-title">Stake 1.0</div>
                <div class="home-staked-overview-data">
                  <span class="home-staked-overview-data-num">19,815,263,162</span>
                  <span class="home-staked-overview-data-tag">
                    <span style="color: rgb(115, 120, 123);">(45.91%)</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="home-view-more">
        <a href="#/data/charts">
          <span>View More Data</span>
          <svg class="icon tron-icon tron-font-size-8px" aria-hidden="true">
            <use xlink:href="/static/media/icons.svg#icon-right-arrow"></use>
          </svg>
        </a>
      </div>  
</template>

<script>
    export default {
        name: "TronTransactions",
        data() {
            return {

            }
        },
        methods: {

        }
    }

</script>